<template>
  <div class="policy-express-item pointer" @click="policyExpressItemClick">
    <div class="policy-express-item-top">
      <div class="basic-info">
        <!--<span class="source">{{data.source}}</span>-->
        <span class="title" :class="{ badge: data.read == 0 }">{{ index + 1 }}. <span v-html="data.essayTitle"></span></span>
      </div>
      <div class="create-time">{{data.updateTime | dateByFormat('yyyy-MM-dd hh:mm:ss')}}</div>
    </div>
    <!--<div class="article" v-html="data.article"></div>-->
  </div>
</template>

<script>
  export default {
    name: "PolicyExpressItem",
    props: {
      data: {
        type: Object,
        default() {
          return {}
        }
      },
      index: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: ''
      }
    },
    methods: {
      policyExpressItemClick() {
        this.$emit('read', {
          index: this.index,
          data: this.data,
          type: this.type
        })
      }
    }
  }
</script>

<style scoped>

</style>
